import styled from 'styled-components';

export const ContentGrid = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) 420px;
  gap: 16px;
  align-items: start;

  @media (max-width: 1200px) {
    grid-template-columns: minmax(0, 1fr);
  }
`;

export const MapCol = styled.div`
  min-width: 0;
  position: relative;
  z-index: 0;
`;

export const SideCol = styled.div`
  min-width: 0;
`;
